import { Reveal } from "./Reveal";
import { FAQS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-12 gap-14">
        <div className="md:col-span-4">
          <div className="md:sticky md:top-36">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] font-medium mb-6">
                Questions
              </p>
              <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight leading-tight text-slate-50">
                Before you <span className="italic text-[#d4af37]">pack.</span>
              </h2>
              <p className="mt-6 text-slate-400 leading-relaxed">
                Everything travellers usually ask us. Something else on your
                mind? Call or WhatsApp — a real person answers.
              </p>
            </Reveal>
          </div>
        </div>
        <div className="md:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  className="border-b border-[#d4af37]/20"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-display text-xl md:text-2xl font-light text-slate-50 hover:text-[#d4af37] hover:no-underline py-7 transition-colors"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="text-slate-400 leading-relaxed pb-7 max-w-2xl"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
